import React, { useEffect, useState } from "react";

const BlurText = ({
  text,
  delay = 100,
  animateBy = "words",
  direction = "top",
  className = "",
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const items = animateBy === "words" ? text.split(" ") : text.split("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsMounted(true);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={`blur-text-wrapper ${className}`}>
      {items.map((item, i) => (
        <span
          key={i}
          className={`blur-text-word direction-${direction}`}
          style={{
            animationDelay: `${i * delay}ms`,
          }}
        >
          {item}
          {animateBy === "words" ? " " : ""}
        </span>
      ))}
    </div>
  );
};

export default BlurText;
